import AttestationStatut from '@/generated/controls/attestation/AttestationStatut.vue';
import { defineComponent } from 'vue';
import Item from '@/framework/base/classes/Item';
import { FieldStatus } from '@/framework/base/components/FieldInfo'
import Attestation from '@/extend/classes/Attestation';

export default defineComponent({
  components: {},
  extends: AttestationStatut,

  data() {
    const items: Item[] = [
      { "key": 1, "title": Attestation.statusLabel(1) },
      { "key": 2, "title": Attestation.statusLabel(2) },
      { "key": 3, "title": Attestation.statusLabel(3) },
      { "key": 4, "title": Attestation.statusLabel(4) },
      { "key": 5, "title": Attestation.statusLabel(5) }
    ];
    return {
      initValue: 0,
      lastContextId: 0,
      status: new FieldStatus(false, false, 0),
      items
    }
  }
})
